import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { WeighPointWiseDeductionReport } from './Pages'

export const WeighPointWiseDeductionReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={WeighPointWiseDeductionReport} />
    </Fragment>
)